import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/questions',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/questions',
                    name: 'questions',
                    component: () => import("./views/questions.vue")
                }
            ]
        }
    ];
};